import React, { Component } from 'react';
import block from 'bem-cn-lite';
import i18n from '../../i18n'

const b = block('Gantt_Calendar');

function getMonday(d, adjust = true) {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day // + (day == 0 && adjust ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
}
const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result
}
const getWeekStart = weekOffset => {
    let startDate = getMonday(new Date());
    return new Date(startDate.setDate(startDate.getDate() + weekOffset * 7));
} 

let dates = []
for(var i = -20; i <= 20; i++) {
    dates.push(i);
}
dates = dates.map(date => getWeekStart(date));
const weekdays = [
    i18n.t('gantt:weekdays.sunday'),
    i18n.t('gantt:weekdays.monday'),
    i18n.t('gantt:weekdays.tuesday'),
    i18n.t('gantt:weekdays.wednesday'),
    i18n.t('gantt:weekdays.thursday'),
    i18n.t('gantt:weekdays.friday'),
    i18n.t('gantt:weekdays.saturday')
]
const months = [
    i18n.t('gantt:months.jan'),
    i18n.t('gantt:months.feb'),
    i18n.t('gantt:months.mar'),
    i18n.t('gantt:months.apr'),
    i18n.t('gantt:months.may'),
    i18n.t('gantt:months.june'),
    i18n.t('gantt:months.jul'),
    i18n.t('gantt:months.aug'),
    i18n.t('gantt:months.sep'),
    i18n.t('gantt:months.oct'),
    i18n.t('gantt:months.nov'),
    i18n.t('gantt:months.dec'),
]

const isBetweenMonths = date => date.getMonth() - addDays(date, 6).getMonth() !== 0; 
const isBetweenYears = date => date.getYear() - addDays(date, 6).getYear() !== 0;
const getWeekDateRange = date => {
    const endOfTheWeekDate = isBetweenMonths(date);
    const dateMonth = months[date.getMonth()];
    const nextDate = addDays(date, 6);
    const nextMonth = endOfTheWeekDate ? months[nextDate.getMonth()] + ' ': '';
    const nextYear = nextDate.getFullYear();
    const year = isBetweenYears(date) ? ', ' + date.getFullYear() : '';
    const nextYearString = isBetweenYears(date) ? ', ' + nextYear : '';
    return `
        ${dateMonth} ${date.getDate()}${year}`
        +`–${nextMonth}${nextDate.getDate()}${nextYearString}`;
}

class Calendar extends Component {
    shouldComponentUpdate() {
        return false;
    }
    render() {
        return <div className={b()}>
            {dates.map(date =>  
                <div key={date} className={b('week')}>
                    <div className={b('week_name')}>
                        {getWeekDateRange(date)}
                    </div>
                    <div className={b('week_days')}>
                        {weekdays.map((weekday, index) => <div key={index}>{weekday}</div>)}
                    </div>
                </div>)
            }
        </div>
    }
}

export default Calendar;